<template>
    <div>
        <ReportNewsLetterGeneration/>
    </div>
</template>

<script>
import ReportNewsLetterGeneration from '../components/ReportNewsLetterGeneration.vue';

export default {
    name: "ReportNewsLetter",
  components: {
    ReportNewsLetterGeneration,
  },
}
</script>